module.exports = __webpack_public_path__ + "static/media/zixi-thumbnail.fd022611.png";